import { useEffect, useState } from "react";
import { useLang } from "@/lib/i18n";
import { mediaUrl } from "@/lib/site";
import { Eyebrow, FadeUp, MaskLine } from "./Reveal";

const Slides = ({ photos }) => {
  const [active, setActive] = useState(0);
  useEffect(() => {
    if (photos.length < 2) return undefined;
    const id = setInterval(() => setActive((a) => (a + 1) % photos.length), 5000);
    return () => clearInterval(id);
  }, [photos.length]);
  return (
    <div className="group relative clip-cut overflow-hidden aspect-[4/5] bg-[var(--ink-3)]">
      {photos.map((src, i) => (
        <img key={src + i} src={src} alt="" className={`absolute inset-0 w-full h-full object-cover grayscale group-hover:grayscale-0 transition-[filter,opacity] duration-1000 ${i === active ? "opacity-100" : "opacity-0"}`} />
      ))}
      {photos.length > 1 && (
        <div className="absolute bottom-4 left-4 flex gap-2">
          {photos.map((src, i) => (
            <button key={src + i} onClick={() => setActive(i)} aria-label={`Photo ${i + 1}`}
              className={`h-1 transition-[width,background-color] duration-500 ${i === active ? "w-8 bg-white" : "w-4 bg-white/40"}`} />
          ))}
        </div>
      )}
    </div>
  );
};

export const CustomSection = ({ s, index }) => {
  const { lang } = useLang();
  const title = s[`title_${lang}`] || s.title_en;
  const body = s[`body_${lang}`] || s.body_en;
  const photos = (s.images || []).map(mediaUrl);
  const words = title.split(" ");
  const half = Math.ceil(words.length / 2);
  return (
    <section id={s.key} data-testid={`custom-section-${s.key}`} className="px-5 sm:px-8 lg:px-12 py-24 sm:py-32 border-t border-[var(--line)]">
      <div className={`grid gap-12 lg:gap-16 ${photos.length ? "lg:grid-cols-2 items-center" : ""}`}>
        <div>
          <Eyebrow>// {String(index + 1).padStart(2, "0")}</Eyebrow>
          <h2 className="font-display font-black uppercase text-5xl sm:text-7xl leading-[0.85] mt-5 break-words">
            <MaskLine>{words.slice(0, half).join(" ")}</MaskLine>
            {words.length > 1 && <MaskLine delay={0.1}>{words.slice(half).join(" ")}</MaskLine>}
          </h2>
          {body && <FadeUp className="mt-8 text-sm sm:text-base text-[var(--muted)] leading-relaxed max-w-xl whitespace-pre-line">{body}</FadeUp>}
        </div>
        {photos.length > 0 && <FadeUp><Slides photos={photos} /></FadeUp>}
      </div>
    </section>
  );
};
